<style scoped lang="less">
.resourbtn {
	padding: 15px 10px;
	// border: 1px solid;
	background-color: #fff;
	margin-bottom: 20px;

	/deep/ .el-button {
		i {
			margin-right: 5px;
			font-size: 16px;
		}

		span {
			margin-right: 0 !important;
		}
	}

	button {
		background-color: #0a68e3;
		border: none;
	}
	button:last-child {
		background-color: #ff8300;
	}

	button:nth-of-type(2) {
		background-color: #ff4168;
	}
}

.manageselect {
	display: flex;
	// border: 1px solid;
	padding: 20px;
	background-color: #fff;
	box-sizing: 0 5px 5px 5px rgba(255, 255, 255, 0.6);
	border-radius: 10px;
	margin-bottom: 20px;
	.sclectlable {
		margin-right: 20px;
	}
}

.tables {
	padding: 0 0.8rem 1.2rem 0.8rem;
	background: #fff;
	box-sizing: border-box;
	border-top: 4px solid #0a68e3;

	.paginations {
		height: 3rem;
		line-height: 3rem;

		input {
			width: 3rem;
			height: 1.8rem;
			padding: 0 0 0 0.8rem;
			border: 1px solid #ccc;
		}
	}

	.tabsnum {
		height: 4rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		p {
			color: #333;
		}

		.elpagian {
			margin-right: 1rem;
		}
	}
}
.tabslis {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	margin-top: 20px;

	button {
		color: #fff;
	}

	/deep/ th {
		text-align: center;
	}

	/deep/ td {
		text-align: center;
	}

	.scostatus {
		margin: auto;
		border-radius: 10px;
		color: #fff;
		width: 60px;
		// padding: 2px 0;
		font-size: 12px;
		background-color: #f41127;
	}

	.tabslisitem {
		display: flex;
		flex-direction: column;
		width: 23%;
		margin: 10px;
		heigth: 100px;
		border: 1px solid #ccc;

		.tabslistitle {
			padding: 10px;
			border-bottom: 1px solid #ccc;

			button {
				background: rgba(229, 63, 60, 1);
				padding: 5px 12px;
				margin-bottom: 10px;
				border-radius: 5px;
			}

			.titledelfont {
				// margin: 5px 0;
				margin-bottom: 10px;
				font-size: 16px;
			}

			.tabslistitledepl {
				display: flex;
				align-items: center;
				justify-content: space-between;
				span {
					margin: 0 2px;
					font-size: 12px;
					color: #999999;
				}
			}
		}

		.tabslisimg {
			width: 100%;
			height: 200px;
			/deep/ .el-image {
				width: 100% !important;
				height: 100% !important;
			}
		}

		.tabslisbtn {
			display: flex;
			// align-items: center;
			justify-content: space-between;
			flex-wrap: wrap;
			padding: 0 10px;
			height: 80px;
			margin: 10px 0;

			button {
				width: 48%;
				color: #666;
				margin: 5px 0;
				height: 30px;
				border-radius: 20px;
				font-size: 14px;
				border: 1px solid #999;
			}

			button:hover {
				background-color: #f1f1f1;
			}
		}
	}
}

.choiostitle {
	display: flex;
	padding: 0.8rem 0.4rem;
	align-items: center;
	justify-content: space-between;
	background-color: #fff;
	margin-bottom: 1rem;
	border-left: 4px solid rgba(84, 123, 235, 1);

	.choiosvspde {
		/deep/ .el-button-group {
			width: 9rem;

			button:first-child {
				width: 7rem;
				height: 2rem;
				padding: 0 3px;
			}

			button:last-child {
				width: 1.6rem;
				height: 2rem;
				position: relative;
				padding: 0;
				top: 0px;
				left: 0px;
			}
		}
	}

	.choiostitleleft {
		padding: 0.5rem;
		font-size: 0.8rem;
		border-radius: 50%;
		color: #fff;
		background-color: rgba(84, 123, 235, 1);
		border: 1px solid;
		text-align: left;
		margin-left: 0.6rem;
		box-sizing: border-box;

		span {
			font-weight: 900;
			font-size: 1.2rem;
		}
	}

	.choiostitleright {
		display: flex;
		align-items: center;
		justify-content: flex-end;

		div {
			margin: 0 0.2rem;
		}

		.choiosipt {
			/deep/ .el-input--prefix .el-input__inner {
				height: 2rem;
				padding: 1rem 2rem;
			}

			/deep/ .el-input__prefix {
				top: -3px;
			}

			/deep/ .el-input__suffix {
				top: -3px;
			}
		}
	}
}

.tabslistbtn {
	// margin-top: 10px;
	margin-left: 10px;
	button {
		height: 40px;
		background-color: #21b573;
	}
}

.choiosflex {
	display: flex;
	align-items: center;
}
</style>
<template>
	<div>
		<titles titlename="学习地图管理" titlecontent="这里可以学习地图管理" :mbx="paths"></titles>

		<div class="choiostitle">
			<div class="choiosflex">
				<button class="choiostitleleft "><img src="../../images/file-text.svg" alt="" style="width: 2rem;height: 2rem;padding: 0.1rem;" /></button>
				<div class="tabslistbtn" @click="goaddmap"><el-button type="success" icon="el-icon-circle-plus">添加新学习地图</el-button></div>
			</div>

			<div class="choiostitleright col-xs-8 col-sm-8 col-md-8 col-lg-8">
				<div class="choiosipt col-xs-4 col-sm-4 col-md-4 col-lg-4">
					<el-input v-model="pagesobj.strWhere" @change="gettabls()" placeholder="请输入查找内容" prefix-icon="el-icon-search"></el-input>
				</div>
			</div>
		</div>

		<div class="tables">
			<div class="tabslist">
				<div class="tabslis">
					<div v-if="tableData.length == 0" style="width: 100%;height: 400px;"><el-empty description="暂无地图记录"></el-empty></div>
					<div class="tabslisitem" v-for="(item, index) in tableData" :key="index">
						<div class="tabslisimg">
							<el-image v-if="!item.LM_CoverImage" src="https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg"></el-image>
							<el-image v-else :src="item.LM_CoverImage"></el-image>
						</div>
						<div class="tabslistitle">
							<button v-if="item.LM_mapStatus == '1'" style="background-color: #19cb98;">已分配</button>
							<button v-if="item.LM_mapStatus == '0'">未分配</button>
							<p class="titledelfont">{{ item.LM_mapName }}</p>
							<div class="tabslistitledepl">
								<p>
									<span class="el-icon-timer"></span>
									<span>{{ item.LM_createTime }}</span>
								</p>

								<!-- <p>
									<span class="el-icon-s-check"></span>
									<span>C20230001班</span>
								</p> -->

								<p>
									<span class="el-icon-s-custom"></span>
									<span>{{ item.ui_realName }}</span>
								</p>
							</div>
						</div>

						<div class="tabslisbtn">
							<button @click="changemaps(item)">
								<span class="el-icon-sort-down"></span>
								<span>分配地图</span>
							</button>
							<button @click="goxq(item)">
								<span class="el-icon-view"></span>
								<span>查看详情</span>
							</button>

							<button @click="editsmap(item)" v-if="item.LM_mapStatus == '0'">
								<span class="el-icon-edit-outline"></span>
								<span>修改编辑</span>
							</button>
							<button @click="chgedeletes(item)" v-if="item.LM_mapStatus == '0'">
								<span class="el-icon-delete"></span>
								<span>删除地图</span>
							</button>
						</div>
					</div>
				</div>
				<div class="tabsnum" v-if="tableData.length > 0">
					<p>
						显示
						<span>1</span>
						到
						<span>{{ tabsnun }}</span>
						,共
						<span>{{ totalall }}</span>
						条记录
					</p>
					<div class="elpagian">
						<el-pagination
							@current-change="changecurr"
							background
							layout="prev, pager, next"
							:page-size="pagesobj.pageSize"
							:total="totalall"
							:current-page="pagesobj.pageIndex"
						></el-pagination>
					</div>
				</div>
			</div>
		</div>

		<el-drawer :visible.sync="drawer" :with-header="false">
			<div style="height: 500px;"><mapchioces ref="mapchioce" @coust-change="setmap"></mapchioces></div>
		</el-drawer>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';

import { AddmapLearningMaps, DistributionMap, MapListLearningMaps, DeletemapLearningMaps } from '@/request/api/homesview/yunhomes/yunhom.js';

import mapchioces from '@/components/chiocesqutions/mapchioces.vue';

import AppOptions from '@/config/AppOptions.vue';

export default {
	data() {
		return {
			drawer: false,
			// 标题
			paths: [
				{
					path: '/homesview/learningmap/learningmap',
					name: '学习地图管理'
				}
			],
			tabsnum: 10,
			totalall: 10,
			tabindex: 1,
			choios: '',
			// 专业筛选项列表
			options: [],
			value: '',
			input: '',
			pagesobj: {
				pageSize: 10,
				pageIndex: 1,
				strWhere: ''
			},
			tabsnun: 1,
			tableData: [],
			mapobj: {}
		};
	},
	components: {
		titles,
		mapchioces
	},
	mounted() {
		this.gettabls();
	},
	created() {
		AppOptions.appEmpty = false;
	},
	methods: {
		chgedeletes(item) {
			this.$confirm('这份地图有人学习，确定删除吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					this.delecmaps();
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
		},

		indexMethod(index) {
			return index + 1;
		},
		editsmap(itm) {
			this.$router.push('/studyplan/learningmap/editslearningmap?LM_GUID=' + itm.LM_GUID);
		},
		delecmaps(itm) {
			let mapsobj = {
				LM_GUID: itm.LM_GUID
			};
			if (itm.LM_mapStatus == '1') {
				// 已分配
				this.$confirm('该地图已分配, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
					.then(() => {
						DeletemapLearningMaps(mapsobj).then(res => {
							if (res.data.code > 0) {
								this.$message.success(res.data.msg);
								this.gettabls();
							}
						});
					})
					.catch(() => {});
			} else {
				DeletemapLearningMaps(mapsobj).then(res => {
					if (res.data.code > 0) {
						this.$message.success(res.data.msg);
						this.gettabls();
					}
				});
			}
		},
		gettabls() {
			MapListLearningMaps(this.pagesobj).then(res => {
				if (res.data.code > 0) {
					// console.log(res.data.data.list);
					this.tableData = res.data.data.list;
					this.totalall = res.data.data.totalCount;
				}
			});
		},
		setmap(list) {
			let lists = Array.from(list);
			this.mapobj.cla_guid = lists;
			DistributionMap(this.mapobj).then(res => {
				if (res.data.code > 0) {
					this.$message.success(res.data.msg);
					this.gettabls();
					this.drawer = false;
				}
			});
		},
		// 应用分配
		changemaps(itm) {
			let maps = {
				LM_GUID: itm.LM_GUID,
				cla_guid: []
			};
			this.mapobj = maps;
			this.drawer = true;
			let that = this;
			setTimeout(() => {
				that.$refs.mapchioce.clearstable();
			}, 200);
		},
		changecurr(val) {
			this.pagesobj.pageIndex = val;
			this.gettabls();
		},
		goxq(itm) {
			this.$router.push('/studyplan/learningmap/learningmapdetil?LM_GUID=' + itm.LM_GUID);
		},
		goaddmap() {
			this.$router.push('/studyplan/learningmap/addlearningmap');
		}
	}
};
</script>
